import { useEffect } from 'react';

import { LayoutList } from 'lucide-react';

import ObjectItem from './Object';
import { TYPE_LABEL, TYPE_PROPERTY, TYPE_VALUE, TYPE_OPTION_LIST } from './types';

export default class OptionListItem extends ObjectItem {
  accept = []
  title = "option-list"
  model = TYPE_OPTION_LIST
  icon = LayoutList

  ItemContent = () => {
    const { props: { children, updateItem, component: { data } } } = this

    useEffect(() => {
      !data && updateItem({
        data: [
          {
            key: 'optionList',
            type: TYPE_PROPERTY,
            value: "{value}",
            model: TYPE_LABEL,
          },
          {
            key: 'optionList',
            type: TYPE_PROPERTY,
            value: "{value}",
            model: TYPE_VALUE,
          },
        ],
      })
    }, [data, updateItem])

    return children
  }
}
